/* eslint-disable no-alert */
import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import App from 'pages/app';
import { PersistGate } from 'redux-persist/integration/react';
import MobileService from 'services/mobile';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { Offline } from '@sentry/integrations';
import { persistor, store } from './store';
import './index.scss';
import 'font-proxima-nova/style.css';
import { startTrackingSession } from './services/tracking-session';

const trackingSession = startTrackingSession();

const tracesSampleRate =
  process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE &&
  parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE);

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,

  integrations: [new Integrations.BrowserTracing(), new Offline()],

  tracesSampleRate:
    tracesSampleRate && !Number.isNaN(tracesSampleRate) ? tracesSampleRate : 0,

  normalizeDepth: 10,

  release: process.env.REACT_APP_RELEASE,
  environment: process.env.REACT_APP_ENV,
  initialScope: {
    tags: {
      platform: MobileService.isMobile ? 'capacitor' : 'web',
      trackingSessionUUID: trackingSession.uuid,
    },
  },
});

const stripeLoadPromise: Promise<Stripe | null> = loadStripe(
  process.env.REACT_APP_STRIPE_CLIENT_API_KEY as string
);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Elements stripe={stripeLoadPromise}>
          <App />
        </Elements>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
